__turbopack_context__.v({
  "className": "jetbrains_mono_26f89a98-module__kDHkxW__className",
});
